import { useUsers } from "../../../hooks/use-user";
import AllUsersDashboard from "../../shared/user-management/dashboard/page";
import UserMetricCards from "../../shared/user-management/matric-cards";

export default function UserManagementDashboardPage() {
  const { data: users = [], isLoading, error } = useUsers();
  return (
    <div className="flex flex-col gap-5 @container 2xl:gap-x-6 2xl:gap-y-7 3xl:gap-8">
      {/* STAT CARD */}
      <UserMetricCards
        className="@2xl:grid-cols-2 @6xl:grid-cols-4 4xl:gap-8"
        users={users}
        isLoading={isLoading}
        error={error}
      />
      {/* STAT CARD */}
      <AllUsersDashboard users={users} isLoading={isLoading} error={error} />
    </div>
  );
}
